import React from 'react'

import DetailsSummarySection from '../../../components/details/summary/DetailsSummarySection'
import DetailStatusMobileHeader from '../../../components/DetailStatusMobileHeader'
import PaymentAttachmentsCard from '../../../components/details/attachments/PaymentAttachmentsCard'
import TotalsSummaryCard from '../../../components/TotalsSummaryCard'

import RefundDetailsMobileLines from './RefundDetailsMobileLines'
import { formatMoney } from '../../../helpers/utils'
import { getRefundWeight } from '../shared/refundDetailsHelpers'

export default function RefundSalesmanDetailsMobile({
  activity,
  statusUI,
  summaryFields,
  fieldsToRender,
  paymentAttachments,
  processedDetails,
  extraColumns,
  totalRows
}) {
  const formattedTotalRows = totalRows.map(row =>
    row
      ? {
          ...row,
          value:
            row.label === 'PESO TOTAL:'
              ? getRefundWeight(row.value)
              : formatMoney(Number(row.value || 0))
        }
      : row
  )

  return (
    <div className="container-fluid px-0">
      <DetailStatusMobileHeader
        title="Detalles de devolución:"
        statusUI={statusUI}
        fallbackStatus={activity?.status}
      />

      <DetailsSummarySection
        summaryFields={summaryFields}
        extraFields={fieldsToRender}
        summaryTitle="DETALLES DEVOLUCION"
        summaryOpenLabel="Abrir detalles de la devolucion"
        summaryCloseLabel="Cerrar detalles de la devolucion"
      />

      <PaymentAttachmentsCard
        images={paymentAttachments.images}
        files={paymentAttachments.files}
        title="ADJUNTO(S)"
        emptyDescription="Cuando esta devolución tenga imágenes o archivos asociados, aparecerán aquí para su revisión."
      />
      <hr />

      <div className="mr-85 mb-10">
        <b>Productos en devolución:</b>
      </div>

      <RefundDetailsMobileLines
        processedDetails={processedDetails}
        extraColumns={extraColumns}
      />

      <TotalsSummaryCard rows={formattedTotalRows} />
    </div>
  )
}
